import React from "react";
import { Link } from "react-router-dom";
import tracklineSS from "../../../assets/product-trackline.png";

const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="trackline-call-to-action-wrapper">
      <div className="" id="callToAction">
        <div
          className="call-to-action-container text-center"
          style={{ backgroundImage: "url('../../assets/bg-pattern.svg')" }}
        >
          <div
            className="position-relative right-side-width"
            style={{ gap: "15px" }}
          >
            <h4 className="title_text">See Trackline in Action</h4>
            <p className="detail-info">
              Ready to discover how Trackline can revolutionize your asset
              management operations? Schedule a live demo and experience the
              power of an intelligent asset management solution.
            </p>
            <Link
              to="/connect-with-us"
              className="btn-md btn-dark border-0"
              onClick={scrollHeader}
            >
              Contact Us
            </Link>
          </div>
          <div className="image-container">
            <img src={tracklineSS} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
